import { render, staticRenderFns } from "./permiss-dialog.vue?vue&type=template&id=43653140"
import script from "./permiss-dialog.vue?vue&type=script&lang=js"
export * from "./permiss-dialog.vue?vue&type=script&lang=js"
import style0 from "./permiss-dialog.vue?vue&type=style&index=0&id=43653140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports